import { useContext } from 'react';
import { TradeOrderDetailTableContext, ITradeOrderDetailTableContext } from './TradeOrderDetailTableContext';

export const useClientDetailsTable = () => useContext<ITradeOrderDetailTableContext>(TradeOrderDetailTableContext);
